var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRaisedHandEmoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6048 25.4412C31.1877 24.6839 31.7182 23.9132 32.6256 22.9591C34.0635 21.4445 35.6281 17.9316 34.1736 14.3653C34.1836 14.3452 33.8867 13.7447 33.8967 13.7247L33.2995 13.6947C33.1093 13.668 26.5405 13.6547 19.965 13.6547C13.3895 13.6547 6.82071 13.668 6.63055 13.6947C6.63055 13.6947 5.74648 14.3452 5.75315 14.3653C4.30194 17.9316 5.86324 21.4412 7.30111 22.9591C8.2052 23.9132 8.73564 24.6839 8.32196 25.4412C7.91829 26.1785 6.71729 26.2852 6.71729 26.2852C6.71729 26.2852 6.99419 27.0392 7.66141 27.4462C8.27859 27.8232 9.03923 27.9099 9.563 27.9233C9.563 27.9233 11.6147 30.7623 16.9792 30.7623H19.965H22.9509C28.3153 30.7623 30.3671 27.9233 30.3671 27.9233C30.8908 27.9099 31.6515 27.8232 32.2686 27.4462C32.9359 27.0392 33.2128 26.2852 33.2128 26.2852C33.2128 26.2852 32.0084 26.1785 31.6048 25.4412Z",
    fill: "#312D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9584 30.7623V27.613L29.4897 26.859L30.357 27.9266C30.357 27.9266 28.3053 30.7656 22.9409 30.7656L19.9584 30.7623Z",
    fill: "url(#paint0_radial_27_141)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.337 26.5487C28.9092 24.3803 32.0752 23.5696 32.0752 23.5696L32.0785 23.5729C31.528 24.2568 31.2778 24.854 31.6014 25.4445C32.0051 26.1818 33.2061 26.2885 33.2061 26.2885C33.2061 26.2885 31.5714 27.7431 30.337 26.5487Z",
    fill: "url(#paint1_radial_27_141)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1803 14.3652C35.5981 17.8181 34.1069 21.3744 32.709 22.8757C32.5189 23.0825 31.7049 23.8799 31.518 24.5171C31.518 24.5171 28.3354 20.0767 27.3846 17.4678C27.1944 16.9407 27.0176 16.4003 26.9942 15.8398C26.9776 15.4195 27.041 14.919 27.2845 14.5621C27.5814 14.125 34.0101 13.9949 34.0101 13.9949C34.0101 14.0016 34.1803 14.3652 34.1803 14.3652Z",
    fill: "url(#paint2_radial_27_141)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75315 14.3652C4.3353 17.8181 5.82655 21.3744 7.22438 22.8757C7.41788 23.0825 8.22856 23.8799 8.41538 24.5171C8.41538 24.5171 11.598 20.0767 12.5488 17.4678C12.7423 16.9407 12.9158 16.4003 12.9392 15.8398C12.9558 15.4195 12.8925 14.919 12.6489 14.5621C12.352 14.125 12.005 14.2418 11.5013 14.2418C10.5405 14.2418 6.33364 13.9949 6.0067 13.9949C6.0067 14.0016 5.75315 14.3652 5.75315 14.3652Z",
    fill: "url(#paint3_radial_27_141)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9717 30.7623V27.613L10.4404 26.8557L9.573 27.9232C9.573 27.9232 11.6247 30.7623 16.9892 30.7623H19.9717Z",
    fill: "url(#paint4_radial_27_141)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59636 26.5487C11.0242 24.3803 7.85824 23.5696 7.85824 23.5696L7.8549 23.5729C8.40536 24.2568 8.65557 24.854 8.33197 25.4445C7.9283 26.1818 6.72729 26.2885 6.72729 26.2885C6.72729 26.2885 8.36199 27.7431 9.59636 26.5487Z",
    fill: "url(#paint5_radial_27_141)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0326 40C36.9459 37.568 34.9742 34.3386 32.4221 32.9975C29.0693 31.2327 24.7724 30.6589 19.9584 30.6589C16.9892 30.6589 14.6272 31.5329 11.8349 30.6555C10.3537 30.1885 9.32947 29.4245 8.8424 27.9266L8.40203 26.5754L0.35197 28.5771C0.35197 28.5771 2.0267 35.8799 2.87741 40H37.0326Z",
    fill: "url(#paint6_linear_27_141)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9584 28.6838H16.9292V32.0133C16.9292 33.5179 18.1635 34.7389 19.6848 34.7389H20.2353C21.7565 34.7389 22.9909 33.5179 22.9909 32.0133V28.6838H19.9584Z",
    fill: "#EDC391"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.076 15.4562H10.8407C8.87575 15.4562 7.26774 17.1709 7.26774 19.2627C7.26774 21.3544 8.87575 23.0692 10.8407 23.0692H29.0726C31.0376 23.0692 32.6456 21.3544 32.6456 19.2627C32.6456 17.1709 31.041 15.4562 29.076 15.4562Z",
    fill: "#EDC391"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9584 2.3252C14.1535 2.3252 8.77568 8.53372 8.77568 17.4712C8.77568 26.3586 14.317 30.7523 19.9584 30.7523C25.5997 30.7523 31.141 26.3553 31.141 17.4679C31.141 8.53372 25.7632 2.3252 19.9584 2.3252Z",
    fill: "#F9DDBD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4738 19.9533C15.3821 19.9533 16.1185 19.1915 16.1185 18.2518C16.1185 17.3122 15.3821 16.5504 14.4738 16.5504C13.5654 16.5504 12.8291 17.3122 12.8291 18.2518C12.8291 19.1915 13.5654 19.9533 14.4738 19.9533Z",
    fill: "#312D2D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4429 19.9533C26.3513 19.9533 27.0877 19.1915 27.0877 18.2518C27.0877 17.3122 26.3513 16.5504 25.4429 16.5504C24.5346 16.5504 23.7982 17.3122 23.7982 18.2518C23.7982 19.1915 24.5346 19.9533 25.4429 19.9533Z",
    fill: "#312D2D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9525 15.2526C16.6422 14.8423 15.9283 14.2485 14.5405 14.2485C13.1527 14.2485 12.4354 14.8456 12.1285 15.2526C11.9917 15.4328 12.0251 15.643 12.1218 15.7697C12.2085 15.8865 12.4688 15.9966 12.7557 15.8999C13.0426 15.8031 13.603 15.5129 14.5405 15.5062C15.4779 15.5129 16.0384 15.8031 16.3253 15.8999C16.6122 15.9966 16.8724 15.8898 16.9592 15.7697C17.0526 15.643 17.086 15.4328 16.9525 15.2526Z",
    fill: "#454140"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7916 15.2526C27.4813 14.8423 26.7674 14.2485 25.3796 14.2485C23.9917 14.2485 23.2745 14.8456 22.9675 15.2526C22.8308 15.4328 22.8641 15.643 22.9609 15.7697C23.0476 15.8865 23.3078 15.9966 23.5947 15.8999C23.8816 15.8031 24.4421 15.5129 25.3796 15.5062C26.317 15.5129 26.8775 15.8031 27.1644 15.8999C27.4513 15.9966 27.7115 15.8898 27.7982 15.7697C27.895 15.643 27.9283 15.4328 27.7916 15.2526Z",
    fill: "#454140"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7674 24.0333C21.7065 24.6639 18.2202 24.6639 17.1594 24.0333C16.5488 23.6697 15.925 24.2268 16.1785 24.7806C16.4287 25.3244 18.327 26.5888 19.9717 26.5888C21.6164 26.5888 23.4913 25.3244 23.7415 24.7806C23.9917 24.2268 23.3779 23.6697 22.7674 24.0333Z",
    fill: "#444444"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2461 21.3377C21.2094 21.3244 21.176 21.3144 21.1393 21.311H18.7774C18.7407 21.3144 18.704 21.3244 18.6706 21.3377C18.4571 21.4245 18.3403 21.6446 18.4404 21.8815C18.5405 22.1184 19.0109 22.7789 19.9584 22.7789C20.9058 22.7789 21.3762 22.115 21.4763 21.8815C21.5764 21.6446 21.4596 21.4245 21.2461 21.3377Z",
    fill: "#DBA689"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5731 7.21591C32.7791 5.98488 30.9842 4.34017 29.3462 4.23008C29.1093 2.65876 27.448 1.32765 25.8233 0.813888C21.4363 -0.580611 18.5372 0.980694 16.9792 1.8214C16.6556 1.99487 14.5639 3.1425 13.1293 2.31848C12.2319 1.80472 12.2719 0.410217 12.2719 0.410217C12.2719 0.410217 9.40954 1.49112 10.3303 4.50364C9.35283 4.54367 8.06509 4.95402 7.36116 6.32516C6.5238 7.95319 6.79069 9.31766 7.01087 9.97154C6.15682 10.6821 5.07258 12.2001 5.7665 14.165C6.28693 15.6463 8.45541 16.3269 8.45541 16.3269C8.25525 18.9924 8.72564 20.6338 8.97918 21.2977C9.02255 21.4144 9.18936 21.4044 9.22272 21.2843C9.57301 19.9632 10.7807 15.3627 10.6806 14.5587C10.6806 14.5587 14.4771 13.8114 18.1335 11.1592C18.8775 10.6187 19.6815 10.1584 20.5355 9.82142C25.0993 8.01991 25.9967 11.0925 25.9967 11.0925C25.9967 11.0925 29.1494 10.4886 30.0234 14.8456C30.3504 16.477 30.5506 19.0892 30.7207 20.9174C30.734 21.0475 30.9075 21.0742 30.9609 20.9541C31.2912 20.2301 31.9484 18.7889 32.1252 17.3244C32.1886 16.8073 33.5931 16.1267 34.2303 13.9082C35.0843 10.9457 34.1469 8.10331 33.5731 7.21591Z",
    fill: "#312D2D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1152 17.331C32.1786 16.8139 33.5831 16.1333 34.2203 13.9148C34.287 13.678 34.3471 13.4378 34.4004 13.1976C34.9342 10.5053 34.1002 8.03324 33.5731 7.21589C32.8391 6.07828 31.2478 4.58703 29.7232 4.28344C29.5897 4.26676 29.4596 4.25008 29.3362 4.24341C29.3362 4.24341 29.4329 4.95734 29.1327 5.52782C28.7457 6.2651 27.9784 6.44191 27.9784 6.44191C31.905 10.4286 31.5647 13.7647 32.1152 17.331Z",
    fill: "url(#paint7_radial_27_141)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9533 1.31766C17.5864 1.49448 17.2594 1.66796 16.9792 1.82142C16.6556 1.9949 14.5638 3.14252 13.1293 2.3185C12.2452 1.81141 12.2686 0.46028 12.2719 0.413574C11.8516 0.934009 10.5472 4.66713 14.1735 4.914C15.7382 5.02076 16.7257 3.65962 17.3161 2.50532C17.5263 2.09164 17.8633 1.48113 17.9533 1.31766Z",
    fill: "url(#paint8_radial_27_141)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3729 0.677131C27.8049 1.33768 28.9726 2.57539 29.3429 4.23344C29.4496 4.72051 29.513 9.2543 20.9292 4.09999C17.7365 2.18506 18.6373 0.984054 19.0176 0.847273C20.4988 0.31683 22.6473 -0.0601518 25.3729 0.677131Z",
    fill: "url(#paint9_radial_27_141)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2586 0.413594C12.2552 0.41693 12.2486 0.41693 12.2386 0.420266C12.2386 0.420266 12.2386 0.420266 12.2352 0.420266C11.9216 0.550375 9.46291 1.67798 10.327 4.50034L12.9158 4.91736C10.6572 2.59208 12.2686 0.406921 12.2686 0.406921C12.2686 0.406921 12.2653 0.413594 12.2586 0.413594Z",
    fill: "url(#paint10_radial_27_141)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9283 4.76054L10.3303 4.50366C10.2669 4.50366 10.0534 4.52368 9.93665 4.54036C9.02922 4.66713 7.95833 5.13085 7.36116 6.32518C6.72063 7.60959 6.71729 8.71385 6.87409 9.44779C6.91746 9.69467 7.01421 9.97157 7.01421 9.97157C7.01421 9.97157 7.82155 9.22094 9.71313 9.1709L11.9283 4.76054Z",
    fill: "url(#paint11_radial_27_141)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93747 10.035C6.13346 10.7355 5.04255 12.2968 5.79651 14.2318C6.36366 15.693 8.46208 16.3269 8.46208 16.3269C8.46208 16.3336 8.88243 16.457 9.09928 16.457L9.71646 9.1709C8.70561 9.1709 7.73147 9.47449 7.09427 9.90818C7.09427 9.91819 6.9308 10.0216 6.93747 10.035Z",
    fill: "url(#paint12_radial_27_141)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3995 9.11752C12.6322 9.12753 11.1777 10.2918 10.5972 11.0391C9.64974 12.2535 8.97918 14.7856 5.85657 13.8114C5.29944 13.6413 3.07424 13.2677 2.69059 13.0441C2.43037 12.894 1.7398 11.663 2.17683 9.14421C2.3403 8.18674 2.73062 5.87147 2.73062 5.87147L3.28108 2.24511C3.35114 1.6346 3.77483 1.24093 4.35198 1.38439C4.8157 1.50115 4.94581 1.91817 4.91245 2.46196L4.78234 4.64378V4.65712C4.78234 4.75387 4.8524 4.84061 4.95248 4.86063C5.06257 4.88064 5.16933 4.81059 5.19268 4.70049C5.35282 3.96988 5.90661 1.43109 6.03005 0.980717C6.17684 0.45361 6.45374 0.0332585 7.04423 0.163367C7.63472 0.29014 7.72813 0.903986 7.62805 1.38772C7.5313 1.86813 6.90078 5.21426 6.90078 5.21426C6.87742 5.33102 6.94081 5.44111 7.0509 5.4678H7.05424C7.15766 5.49115 7.26441 5.4211 7.29444 5.311L8.66892 0.790558C8.83239 0.196728 9.33948 -0.166909 9.88327 0.076628C10.317 0.273459 10.4137 0.773878 10.2769 1.27096L9.11262 5.88482C9.09928 5.93819 9.12597 5.99491 9.17601 6.01159H9.17935C9.22605 6.02493 9.27943 5.99824 9.29611 5.9482L10.8641 2.1617C11.0509 1.68464 11.4646 1.35103 11.925 1.47113C12.5121 1.61792 12.6856 2.21508 12.4654 2.78556C12.4654 2.78556 10.9675 6.87898 10.4938 8.14004C10.4871 8.16339 10.4771 8.18674 10.4704 8.20676C10.4671 8.21343 10.4638 8.21677 10.4638 8.2201C10.4237 8.33019 10.4771 8.43695 10.5672 8.48032C10.5939 8.49366 10.6239 8.50034 10.6539 8.50034C10.6873 8.50034 10.7206 8.49033 10.754 8.47698C10.784 8.4603 10.814 8.44696 10.8407 8.42694L10.8708 8.40692C11.3445 8.11335 11.7949 7.46947 12.5288 7.37273C13.3295 7.26597 13.8466 7.56622 14.0167 7.91318C14.1635 8.20342 14.1702 9.10417 13.3995 9.11752Z",
    fill: "url(#paint13_linear_27_141)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32863 26.3419C8.1685 25.6947 8.10845 25.0275 8.14848 24.3636L8.35866 14.6288C8.37534 14.3619 8.23522 14.1217 8.01504 14.0016C7.93497 13.9516 7.8449 13.9149 7.74815 13.9015L2.42036 12.6672C2.07674 12.6238 1.75647 12.8507 1.68308 13.1876C1.68308 13.1876 0.305261 23.5029 0.205177 24.3236C0.105094 25.1443 -0.148451 26.1351 0.118438 27.3861L0.358639 28.5705L8.9625 28.3403L8.32863 26.3419Z",
    fill: "url(#paint14_linear_27_141)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5672 8.48029C9.5263 8.527 8.48543 8.65043 7.58134 9.11415C7.12763 9.35102 6.7273 9.67796 6.38701 10.0683C6.11345 10.3785 5.89327 10.7288 5.6931 11.1058C5.68643 11.1225 5.66975 11.1325 5.6564 11.1325C5.63305 11.1325 5.6197 11.1158 5.61637 11.0958V11.0925C5.61637 11.0825 5.91662 10.2551 6.16349 9.89481C6.47375 9.43442 6.90745 9.05077 7.40119 8.77721C7.8916 8.50364 8.42872 8.32683 8.97251 8.23675C9.4796 8.14668 9.99002 8.11999 10.4938 8.14001C10.4871 8.16336 10.4771 8.18671 10.4704 8.20673C10.4671 8.2134 10.4638 8.21674 10.4638 8.22007C10.4237 8.33017 10.4771 8.43692 10.5672 8.48029Z",
    fill: "#EDBD82"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8272 26.2105) scale(7.81286 3.83768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7275,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5231 25.048) rotate(154.924) scale(2.30878 1.71279)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6628,
    stopColor: "#454140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5393 18.5179) rotate(-94.2783) scale(10.1414 8.45221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7247,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3928 18.5176) rotate(-85.7217) scale(10.1414 8.45221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7247,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1045 26.2105) rotate(180) scale(7.81286 3.83768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7275,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.4094 25.0483) rotate(25.0761) scale(2.30878 1.71279)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6628,
    stopColor: "#454140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_27_141",
    x1: 18.6936,
    y1: 26.7091,
    x2: 18.6936,
    y2: 37.6969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F37F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6D23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1118 13.1865) rotate(72.9338) scale(11.8034 8.86174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6985,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.745 0.255532) rotate(28.3598) scale(3.09314 3.71518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#454140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.614 5.90745) rotate(-157.095) scale(9.68516 5.50046)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6985,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4444 3.09293) scale(2.86089 3.49115)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7016,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9652 8.13117) rotate(-164.908) scale(5.34166 5.0314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6605,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_27_141",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6034 13.3001) rotate(7.83526) scale(5.6198 7.91567)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5981,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_27_141",
    x1: 9.46982,
    y1: 1.95313,
    x2: 6.8135,
    y2: 13.3957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9DDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD29C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_27_141",
    x1: 4.47501,
    y1: 26.3061,
    x2: 4.47501,
    y2: 50.6594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0015,
    stopColor: "#F78C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    stopColor: "#F37F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6D23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisedHandEmoji);
export default __webpack_public_path__ + "static/media/raised-hand-emoji.f5c61b629946ea2ed28ca8e7759c747d.svg";
export { ForwardRef as ReactComponent };